const TOTAL_ACCESS_ATTEMPTS_BEFORE_SHOW_CAPTCHA = 3;

function shouldShowCaptcha(blockedUser, totalAttempts) {
  return !blockedUser
    && totalAttempts >= TOTAL_ACCESS_ATTEMPTS_BEFORE_SHOW_CAPTCHA;
}

function extractErrorInformation(error) {
  const {
    parametros: parameters,
    codigoMensagem: messageCode,
    totalTentativas: wrongAttempts,
    usuarioBloqueado: blockedUserInBody = false,
  } = error.response?.data || {};
  const { tentativasDeAcessoComFalha: failedAttempts = 0 } = parameters || {};
  const blockedUser = messageCode === 'ME004';

  const failedAttemptsBasedOnParameters = parameters[1] ?? 0;

  return {
    blockedUser: blockedUserInBody || blockedUser,
    wrongAttempts: wrongAttempts || failedAttempts || failedAttemptsBasedOnParameters,
  };
}

export default {
  shouldShowCaptcha,
  extractErrorInformation,
};
